import { useQuery } from "@apollo/client";
import type { Agent, Connection } from "@casey/db-types";
import { GET_CONNECTIONS_BY_AGENT } from "../gql";

export interface ConnectionsByAgentData {
  agent: Agent & {
    connections: {
      nodes: Connection[];
    };
  };
}

export interface ConnectionsByAgentVariables {
  agentId: string;
}

export function useConnectionsByAgent(agentId: string) {
  const { data, loading, error, refetch } = useQuery<
    ConnectionsByAgentData,
    ConnectionsByAgentVariables
  >(GET_CONNECTIONS_BY_AGENT, {
    variables: { agentId },
    skip: !agentId,
    errorPolicy: "all",
  });

  const connections = data?.agent?.connections?.nodes || [];

  return {
    agent: data?.agent,
    connections,
    loading,
    error,
    refetch,
  };
}


